import { motion } from "framer-motion";
import { 
  Accordion, 
  AccordionContent, 
  AccordionItem, 
  AccordionTrigger 
} from "@/components/ui/accordion";
import { MessageCircleQuestion } from "lucide-react";

const faqs = [
  {
    question: "Já uso planilha pra controlar meus projetos...",
    answer: "Planilhas funcionam até certo ponto, mas não calculam seu valor hora real automaticamente, não projetam sua receita do mês, e não te alertam sobre riscos de concentração de clientes. O FreelaDash faz tudo isso em tempo real, sem você precisar criar fórmulas ou atualizar manualmente.",
  },
  {
    question: "Uso o Notion para organizar meus projetos.",
    answer: "O Notion é excelente para documentação e organização geral, mas não foi feito para controle financeiro de freelancer. Ele não tem timer integrado, não calcula margem de lucro por projeto, e não projeta seu faturamento. O FreelaDash complementa o Notion focando no que ele não faz: sua inteligência financeira.",
  },
  {
    question: "Já uso Toggl para registrar minhas horas.",
    answer: "O Toggl é um ótimo timer, mas ele para por aí. Ele não te mostra quanto você realmente ganhou, não calcula se um projeto deu lucro, não projeta sua receita mensal. O FreelaDash integra o timer com inteligência financeira real — você vê o impacto de cada hora no seu bolso.",
  },
  {
    question: "Quanto tempo leva para configurar?",
    answer: "Menos de 3 minutos. Você informa sua meta mensal, seu valor hora desejado e seu regime tributário. Pronto. Pode começar a registrar tempo imediatamente. Tudo o mais é calculado automaticamente pelo sistema.",
  },
  {
    question: "E se eu cancelar, perco meus dados?",
    answer: "Não. Seus dados são seus. Mesmo após o período de teste, você mantém acesso ao histórico. E você pode exportar todos os seus dados a qualquer momento. Sem amarras.",
  },
  {
    question: "Funciona para qualquer tipo de freelancer?",
    answer: "Sim. O FreelaDash foi pensado para qualquer profissional que vende seu tempo: desenvolvedores, designers, redatores, consultores, social media, tradutores... Se você cobra por hora ou por projeto, o sistema funciona para você.",
  },
];

export function FAQSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-background to-muted/30 overflow-hidden">
      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-muted border border-border text-muted-foreground text-sm font-medium mb-6">
            <MessageCircleQuestion className="h-4 w-4" />
            Dúvidas frequentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground">
            VOCÊ PODE ESTAR PENSANDO...
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border rounded-xl bg-card px-6 data-[state=open]:border-primary/30 transition-colors"
              >
                <AccordionTrigger className="text-left text-foreground hover:text-primary hover:no-underline py-5 text-base sm:text-lg font-medium">
                  "{faq.question}"
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
